var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 107.491,
    height: 112.645,
    viewBox: "0 0 107.491 112.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86dd0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12a317"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_21-Leaf_-_Outline",
    "data-name": "21-Leaf - Outline",
    d: "M191.31,79.636a4.421,4.421,0,0,1,3.747,2.074,66.632,66.632,0,0,1-34.232,98.242,66.318,66.318,0,0,1-38.994,1.635,203.221,203.221,0,0,1-17.649,10.223,4.28,4.28,0,0,1-1.967.472,4.413,4.413,0,0,1-2.087-8.334c5.084-2.637,9.983-5.432,14.6-8.328a43.391,43.391,0,0,1,14.751-62.949,84.754,84.754,0,0,1,17.509-7.63,109.518,109.518,0,0,0,23.037-10.661A127.927,127.927,0,0,0,188.4,80.73,4.419,4.419,0,0,1,191.31,79.636Zm-89.1,108.508c.038,0,20.338-10.643,20.482-10.608C127.931,178.924,102.067,188.144,102.215,188.144Zm36.618-13.24a57.518,57.518,0,0,0,25.765-6.119,58.2,58.2,0,0,0,20.569-17.444,57.359,57.359,0,0,0,4.93-60.476,128.442,128.442,0,0,1-15.535,11.091,118.568,118.568,0,0,1-24.914,11.5l-.309.1H149.3a74.928,74.928,0,0,0-14.414,6.191l-1.537.876a34.543,34.543,0,0,0-11.257,50.088,159,159,0,0,0,15.047-11.965,165.266,165.266,0,0,0,30.712-37.7,4.424,4.424,0,0,1,7.566,4.587,174.009,174.009,0,0,1-32.347,39.691c-3.564,3.2-7.3,6.274-11.138,9.169A58,58,0,0,0,138.833,174.9Z",
    transform: "translate(-97.754 -79.636)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.19b8e52d092d97bc7ba646cf93498b52.svg";
export { ForwardRef as ReactComponent };